<div class="react-task-settings">
	<div class="react-task-settings-input-group">
		@if (shouldShowPrivacy()) {
			<div class="form-group">
				<mat-form-field appearance="outline" class="react-task-settings-privacy-select">
					<mat-label>{{ 'activity-task-additional-settings_feedback-privacy' | translate }}</mat-label>
					<mat-select [formControl]="privacyControl">
						<mat-select-trigger>
							{{ getSelectedPrivacyOption()?.titleKey | translate }}
						</mat-select-trigger>
						@for (option of privacyOptions; track option.key) {
							<mat-option [value]="option.key">
								<div class="react-task-settings-privacy-option">
									<div class="react-task-settings-privacy-option-title">{{ option.titleKey | translate }}</div>
									<div class="react-task-settings-privacy-option-description">{{ option.descriptionKey | translate }}</div>
								</div>
							</mat-option>
						}
					</mat-select>
					<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
				</mat-form-field>
			</div>
		}
	</div>
</div>
